import { useDialog, useMobileMenu, usePlatformStore } from "@platform/store";
import { useFetchUserCircles } from "@core/features/circle";
import { ProgramMeetingInformationDialog } from "./ProgramMeetingInformationDialog";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";
import { useUserMeetings } from "@platform/hooks/useUserMeetings";

export function ProgramMeetingInformationContainer() {
  const { activeDialog, closeDialog } = useDialog();
  const user = usePlatformStore((s) => s.user);

  const { close: closeMobileMenu } = useMobileMenu();

  const isOpen = activeDialog === "meetingInformation";

  const { data: circlesData } = useFetchUserCircles({ user });
  const circle = circlesData?.circles?.[0];

  const { meetings } = useUserMeetings();

  const userTimezoneOption = useUserTimezoneOption();

  const handleDone = async () => {
    // close the dialog
    closeDialog();

    closeMobileMenu();
  };

  if (!userTimezoneOption) return null;
  if (!circle) return null;

  return (
    <ProgramMeetingInformationDialog
      circle={circle}
      meetings={meetings}
      userTimezoneOption={userTimezoneOption}
      onClose={handleDone}
      isOpen={isOpen}
    />
  );
}

export default ProgramMeetingInformationContainer;

